import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import Strings from "../../res/String";
import InputField from "../inputField/InputField";
import Model from "../model/Model";
import Images from "../../assets";
import PopUpModal from "../popupmodal/PopUpModal";
import logo from "../../assets/img/timber_logo.png";
import axios from "axios";
import deleteIcon from "../../assets/img/delete.svg";
import searchIcon from "../../assets/img/search.png";
import addIcon from "../../assets/img/addUser.png";

import { jsPDF } from "jspdf";
import "jspdf-autotable";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

import { useNavigate } from "react-router-dom";
import { useMutation, useQuery } from "react-query";
import { useSelector } from "react-redux";
import moment from "moment";
import { light } from "@mui/material/styles/createPalette";
import { pink } from "@mui/material/colors";

// Fetch user details
export const fetchUserDetails = async () => {
  return await axios.get(`${process.env.REACT_APP_HOST}/packinglist/all`);
};

export default function AgentManagementCom() {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const { control, handleSubmit, watch, setValue } = useForm({});
  const [currentPage, setCurrentPage] = useState(1);
  const [statusValue, setStatusValue] = useState();
  const [agentValue, setAgentValue] = useState();

  const [deleteIndex, setDeleteIndex] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [deletePopUp, setDeletePopUp] = useState(false);
  const [downloadPopUp, setDownloadPopUp] = useState(false);
  const [sharePopUp, setSharePopUp] = useState(false);
  const [shareNotification, setShareNotification] = useState(false);
  const [modifyPopup, setModifyPopup] = useState(false);

  const [popUpData, setPopUpData] = useState({
    key: "",
    items: "",
  });
  const values = useSelector((state) => state.loginData);

  const togglePopup = () => {
    setPopupOpen(!isPopupOpen);
  };
  const toggleShare = () => {
    setSharePopUp(!sharePopUp);
  };
  const toggleShareNotification = () => {
    setShareNotification(!shareNotification);
  };

  // console.log('fetchUserDetails',fetchUserDetails);

  // GET API
  const { data, isLoading, isError, refetch } = useQuery(
    "data",
    fetchUserDetails
  );
  let details = data && data?.data;

  const HandlerDelete = async (itemId) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_HOST}/packinglistdetails/bulk`,
        {
          data: deleteIndex,
        }
      );
      refetch();
      document.getElementById("myCheckbox").checked = false;
      setDeletePopUp(!deletePopUp);
      setPopupOpen(false);
      return response.data;
    } catch (error) {
      console.log("Error", error);
    }
  };

  let actionFilterValue =
    details &&
    details
      ?.filter((item) => {
        if (!statusValue && !agentValue) {
          return true;
        }
        if (statusValue && agentValue) {
          return item?.status === statusValue && item?.agentName === agentValue;
        }
        if (statusValue) {
          return item?.status === statusValue;
        }
        if (agentValue) {
          return item?.agentName === agentValue;
        }
      })
      ?.sort((a, b) => {
        const fileIdA = isNaN(Number(a.fileId)) ? a.fileId : Number(a.fileId);
        const fileIdB = isNaN(Number(b.fileId)) ? b.fileId : Number(b.fileId);

        if (typeof fileIdA === "number" && typeof fileIdB === "number") {
          return fileIdA - fileIdB;
        } else {
          return String(fileIdA).localeCompare(String(fileIdB));
        }
      });

  const filteredData =
    actionFilterValue &&
    actionFilterValue?.filter((item) => {
      if (item?.id) return true;

      if (!searchTerm) return true;

      return item?.fileId?.toLowerCase().startsWith(searchTerm?.toLowerCase());
    });

  // Download Start
  const filterdataFile =
    details &&
    details?.filter((item) => {
      if (selectedRows?.length !== 0) {
        return selectedRows?.includes(item?.id);
      }
    });

  // DELETE API
  // Delete a user by ID
  const deleteUser = async (id) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_HOST}/packinglist/delete/${id}`
        // `${process.env.REACT_APP_HOST}/packinglistdetails/bulk`
      );
      return response.data;
    } catch (error) {
      console.error(`Error deleting user with ID ${id}:`, error);
      throw error;
    }
  };

  const deleteUsers = async (ids) => {
    try {
      const results = await Promise.all(
        ids?.map(async (id) => {
          return await deleteUser(id);
        })
      );
      return results; // Return all results after deletion
    } catch (error) {
      console.error("Error deleting multiple users:", error.message);
      throw new Error("Failed to delete multiple users");
    }
  };
  // Mutation to delete users
  const mutation = useMutation({
    mutationFn: deleteUsers,
    onSuccess: () => {
      setDeletePopUp(true);
      setSelectedRows([]);
      refetch();
    },
    onError: (error) => {
      console.error("Error deleting rows:", error);
      alert("Error deleting rows");
    },
  });

  // Handle checkbox change
  const handleCheckboxChange = (id) => {
    setSelectedRows((prevSelectedRows) => {
      const isSelected = prevSelectedRows?.includes(id);
      if (isSelected) {
        return prevSelectedRows?.filter((rowId) => rowId !== id);
      } else {
        return [...prevSelectedRows, id];
      }
    });
  };
  // Handle delete button click
  const handleDelete = () => {
    if (selectedRows?.length === 0) {
      alert("No rows selected");
      return;
    }
    mutation.mutate(selectedRows);
  };

  // DELETE API END

  const downloadExcel = () => {
    // Define headers
    const headers = [
      "S.no",
      "FILE ID",
      "DATE",
      "AGENT",
      "PARTY NAME",
      "PKL",
      "CBM",
      "COMM",
      "LOAD",
      "RECEIVED",
      "PAID",
      "BALANCE",
      "STATUS",
    ];

    // Map data to match the headers order
    const formattedData =
      selectedRows?.length !== 0
        ? filterdataFile?.map((item, index) => ({
            "S.no": index + 1,
            "FILE ID": item.fileId || "",
            DATE: item.date || "",
            AGENT: item.agentName || "",
            "PARTY NAME": item.partyName || "",
            PKL: item.pkl || "",
            CBM: item.cbm || "",
            COMM: item.comm || "",
            LOAD: item.load || "",
            RECEIVED: item.received || "",
            PAID: item.paidAmount || "",
            BALANCE: item.balanceAmount || "",
            STATUS: item.status || "",
          }))
        : filteredData &&
          filteredData?.map((item, index) => ({
            "S.no": index + 1,
            "FILE ID": item.fileId || "",
            DATE: item.date || "",
            AGENT: item.agentName || "",
            "PARTY NAME": item.partyName || "",
            PKL: item.pkl || "",
            CBM: item.cbm || "",
            COMM: item.comm || "",
            LOAD: item.load || "",
            RECEIVED: item.received || "",
            PAID: item.paidAmount || "",
            BALANCE: item.balanceAmount || "",
            STATUS: item.status || "",
          }));

    // Create a new workbook and a worksheet
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(formattedData, { header: headers });

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Generate Excel file and trigger download
    XLSX.writeFile(wb, "Data.xlsx");
  };
  // Download End
  let totalCbm = 0;
  let totalComm = 0;
  let totalLoad = 0;
  let totalReceived = 0;
  let totalPaid = 0;
  let totalBalance = 0;

  const handleWhatsAppClick = () => {
    const whatsappUrl = "https://api.whatsapp.com/";
    window.open(whatsappUrl, "_blank");
  };

  const handleGmailClick = () => {
    const gmailUrl = "mailto:";
    window.location.href = gmailUrl;
  };

  return (
    <>
      {(values?.role === "superAdmin" || values?.role === "admin") && (
        <>
          <div className="headerTimeLine px-3 py-3">
            <div className="row">
              <div className="col-12 col-lg-4 mb-3 mb-lg-0">
                <div className="agent-search-block">
                  <input
                    type="search"
                    className="table-search"
                    value={searchTerm}
                    placeholder="search by fileId"
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  <div className="image_icon">
                    <img
                      src={searchIcon}
                      style={{ width: "100%", height: "100%" }}
                      alt="Search"
                    />
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-8 mb-3 mb-lg-0">
                <div className="d-flex flex-wrap align-items-center justify-content-lg-end gap-2">
                  <div className="agent-btn-block">
                    <select
                      className="new-user-btn text-center"
                      onChange={(event) => {
                        setAgentValue(event.target.value);
                      }}
                    >
                      <option value="">Agent</option>
                      {[
                        ...new Set(details?.map((data) => data?.agentName)),
                      ].map((agentName, index) => {
                        return (
                          <>
                            <option key={index} value={agentName}>
                              {agentName}
                            </option>
                          </>
                        );
                      })}
                    </select>
                  </div>
                  <div className="agent-btn-block">
                    <select
                      className="new-user-btn text-center"
                      onChange={(event) => {
                        setStatusValue(event.target.value);
                      }}
                    >
                      <option value="">STATUS</option>
                      <option value="active">ACTIVE</option>
                      <option value="inactive">INACTIVE</option>
                    </select>
                  </div>
                  <div
                    className="agent-btn-block"
                    onClick={() => navigate("/newPackingList")}
                  >
                    <button className="new-user-btn">NEW PKL</button>
                  </div>
                  <div className="agent-btn-block" onClick={downloadExcel}>
                    <button className="new-user-btn">DOWNLOAD</button>
                  </div>
                  {selectedRows?.length !== 0 ? (
                    <div className="agent-btn-block">
                      <button
                        className="new-user-btn"
                        onClick={() => {
                          setPopupOpen(true);
                        }}
                      >
                        DELETE
                      </button>
                      <div className="image_icon">
                        <img
                          src={deleteIcon}
                          className="img-icon"
                          alt="Delete"
                        />
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {values?.role == "limitedAdmin" && (
        <>
          <div className="headerTimeLine px-3 py-3">
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex search-block">
                <input
                  type="search"
                  className="table-search"
                  value={searchTerm}
                  placeholder="search by fileId"
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <div className="image_icon">
                  <img
                    src={searchIcon}
                    style={{ width: "100%", height: "100%" }}
                    alt="Search"
                  />
                </div>
              </div>
              <div className="d-flex gap-2 align-items-center">
                <div className="add-user-btn-block">
                  <select
                    className="new-user-btn text-center"
                    onChange={(event) => {
                      setAgentValue(event.target.value);
                    }}
                  >
                    <option value="">Agent</option>
                    {[...new Set(details?.map((data) => data?.agentName))].map(
                      (agentName, index) => {
                        // console.log("agentName", agentName);
                        return (
                          <>
                            <option key={index} value={agentName}>
                              {agentName}
                            </option>
                          </>
                        );
                      }
                    )}
                  </select>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      <div className="view-table-block">
        <div className="table-responsive agent-management-table">
          {(values?.role == "superAdmin" || values?.role == "admin") && (
            <>
              <table className="table">
                <thead>
                  <tr style={{ position: "sticky", top: "0px" }}>
                    <th className="agent-view-user-table-head --first-head">
                      SELECT / EDIT
                    </th>
                    <th
                      className="agent-view-user-table-head"
                      style={{ minWidth: "40px" }}
                    >
                      S.NO
                    </th>

                    <th className="agent-view-user-table-head">FILE ID</th>
                    <th
                      className="agent-view-user-table-head"
                      style={{ minWidth: "90px" }}
                    >
                      DATE
                    </th>
                    <th className="agent-view-user-table-head">AGENT</th>
                    <th
                      className="agent-view-user-table-head"
                      style={{ minWidth: "145px" }}
                    >
                      PARTY NAME
                    </th>
                    <th className="agent-view-user-table-head">PKL</th>
                    <th className="agent-view-user-table-head">CBM</th>
                    <th className="agent-view-user-table-head">COMM</th>
                    <th className="agent-view-user-table-head">LOAD</th>
                    <th className="agent-view-user-table-head">RECEIVED</th>
                    <th className="agent-view-user-table-head">PAID</th>
                    <th className="agent-view-user-table-head">BALANCE</th>
                    <th className="agent-view-user-table-head">STATUS</th>
                    <th className="agent-view-user-table-head --last-head">
                      REPORT
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading ? (
                    <div
                      style={{ width: "200%", fontWeight: "900" }}
                      className="py-2 px-4"
                    >
                      L O A D I N G . . .
                    </div>
                  ) : filteredData?.length !== 0 ? (
                    filteredData &&
                    filteredData?.map((val, i) => {
                      totalCbm = Number(val?.cbm) + totalCbm;
                      totalBalance = Number(val?.balanceAmount) + totalBalance;
                      totalComm = Number(val?.comm) + totalComm;
                      totalLoad =
                        Number(val?.loadvalue) +
                        Number(val?.sumMTS) +
                        totalLoad;
                      totalReceived = Number(val?.received) + totalReceived;
                      totalPaid = Number(val?.paidAmount) + totalPaid;
                      return (
                        <tr key={i} className="view-user-table-row">
                          <td className="agent-view-user-table-data">
                            <div className="d-flex align-items-center justify-content-center">
                              <input
                                type="checkbox"
                                checked={selectedRows?.includes(val?.id)}
                                onChange={() => handleCheckboxChange(val?.id)}
                              />
                              <div
                                onClick={() =>
                                  navigate("/newPackingList", { state: val })
                                }
                              >
                                <img
                                  src={Images?.editpencil}
                                  style={{ width: "50px", height: "25px" }}
                                  alt="Edit"
                                />
                              </div>
                            </div>
                          </td>
                          <td
                            className="agent-view-user-table-data"
                            style={{ minWidth: "40px" }}
                          >
                            {i + 1}
                          </td>
                          <td className="agent-view-user-table-data">
                            {val?.fileId || "-"}
                          </td>
                          <td
                            className="agent-view-user-table-data"
                            style={{ minWidth: "90px" }}
                          >
                            {val?.date || "-"}
                          </td>
                          <td className="agent-view-user-table-data">
                            {val?.agentName || "-"}
                          </td>
                          <td
                            className="agent-view-user-table-data"
                            style={{ minWidth: "145px" }}
                          >
                            {val?.partyName || "-"}
                          </td>
                          <td className="agent-view-user-table-data">
                            {val?.pkl || "-"}
                          </td>
                          <td className="agent-view-user-table-data">
                            {val?.cbm || "-"}
                          </td>
                          <td className="agent-view-user-table-data">
                            {val?.comm || "-"}
                          </td>
                          <td className="agent-view-user-table-data">
                            {val?.loadvalue != null || val?.sumMTS != null
                              ? Number(val?.loadvalue ?? 0) +
                                Number(val?.sumMTS ?? 0)
                              : "-"}
                          </td>

                          <td className="agent-view-user-table-data">
                            {val?.received || "-"}
                          </td>
                          <td className="agent-view-user-table-data">
                            {val?.paidAmount || "-"}
                          </td>
                          <td className="agent-view-user-table-data">
                            {val?.balanceAmount || "-"}
                          </td>
                          <td className="agent-view-user-table-data">
                            {val?.status || "-"}
                          </td>
                          {/* <td className="agent-view-user-table-data">
                            <div className="d-flex align-items-center justify-content-center gap-1">
                              <button
                                className="packinglist-view-btn"
                                onClick={() => {
                                  setDownloadPopUp(true);
                                  setPopUpData({
                                    ...popUpData,
                                    key: "pklreport",
                                    items: val,
                                  });
                                }}
                              >
                                PKL REPORT
                              </button>


                              <button 
                                className="packinglist-view-btn"
                                onClick={() => {
                                  setDownloadPopUp(true);
                                  setPopUpData({
                                    ...popUpData,
                                    key: "mgirthpklreport",
                                    items: val,
                                  });
                                }}
                              >
                                M-GIRTH PKL REPORT
                              </button>
                              <button
                                className="packinglist-view-btn"
                                onClick={() => {
                                  setDownloadPopUp(true);
                                  setPopUpData({
                                    ...popUpData,
                                    key: "acreport",
                                    items: val,
                                  });
                                }}
                              >
                                AC REPORT
                              </button>
                            </div>
                          </td> */}
                          <td className="agent-view-user-table-data">
                            <div className="d-flex align-items-center justify-content-center gap-1">
                              {/* <button
                                className="packinglist-view-btn"
                                onClick={() => {
                                  localStorage.setItem("currentStep", 3);
                                  navigate("/newPackingList", { state: val });
                                }}
                              >
                                MODIFY GIRTH
                              </button> */}
                              <button
                                className="packinglist-view-btn"
                                onClick={() => {
                                  setModifyPopup(true);
                                  setPopUpData({
                                    ...popUpData,
                                    items: val,
                                  });
                                }}
                              >
                                DOWNLOAD REPORT
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <h4 className="py-2 data-entry-sub-title">
                      No Records Found
                    </h4>
                  )}
                </tbody>
                <tfoot>
                  <tr>
                    <td
                      colSpan="7"
                      className="agent-view-user-table-data agent-view-totalAmt"
                    >
                      Total
                    </td>
                    <td className="agent-view-user-table-data agent-view-totalAmt">
                      {totalCbm}
                    </td>
                    <td className="agent-view-user-table-data agent-view-totalAmt">
                      {totalComm.toFixed(2)}
                    </td>
                    <td className="agent-view-user-table-data agent-view-totalAmt">
                      {totalLoad.toFixed(2)}
                    </td>
                    <td className="agent-view-user-table-data agent-view-totalAmt">
                      {totalReceived.toFixed(2)}
                    </td>
                    <td className="agent-view-user-table-data agent-view-totalAmt">
                      {totalPaid}
                    </td>
                    <td className="agent-view-user-table-data agent-view-totalAmt">
                      {totalBalance.toFixed(2)}
                    </td>
                    <td
                      colSpan="3"
                      className="agent-view-user-table-data agent-view-totalAmt"
                    ></td>
                  </tr>
                </tfoot>
              </table>
            </>
          )}
          {values?.role == "limitedAdmin" && (
            <>
              <table className="table">
                <thead>
                  <tr style={{ position: "sticky", top: "0px" }}>
                    <th className="agent-view-user-table-head --first-head">
                      EDIT
                    </th>
                    <th className="agent-view-user-table-head ">
                      CONTAINER NO
                    </th>
                    <th className="agent-view-user-table-head">PKL NO</th>
                    <th className="agent-view-user-table-head">LORRY NO</th>
                    <th className="agent-view-user-table-head">AGENT</th>
                    <th className="agent-view-user-table-head">DATE</th>
                    <th className="agent-view-user-table-head --last-head">
                      REPORT
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading ? (
                    <tr>
                      <td
                        colSpan="16"
                        style={{ textAlign: "center", fontWeight: "900" }}
                      >
                        L O A D I N G . . .
                      </td>
                    </tr>
                  ) : filteredData?.length !== 0 ? (
                    filteredData?.map((val, index) => {
                      const currentDate = new Date()
                        .toISOString()
                        .split("T")[0]; // Current date in YYYY-MM-DD format
                      const isEditable = val?.date === currentDate; // Check if dates match

                      return (
                        <tr key={val?.index} className="view-user-table-row">
                          {/* Edit Button */}
                          <td className="agent-view-user-table-data">
                            <div
                              onClick={() => {
                                if (isEditable) {
                                  navigate("/newPackingList", { state: val });
                                }
                              }}
                              style={{
                                cursor: isEditable ? "pointer" : "not-allowed",
                                opacity: isEditable ? 1 : 0.5,
                              }}
                              title={
                                isEditable
                                  ? "Click to edit"
                                  : "Editing disabled for this date"
                              }
                            >
                              <img
                                src={Images?.editpencil}
                                style={{ width: "50px", height: "25px" }}
                                alt="Edit"
                              />
                            </div>
                          </td>

                          {/* Other Data Fields */}
                          <td className="agent-view-user-table-data">
                            {val?.container || "-"}
                          </td>
                          <td className="agent-view-user-table-data">
                            {val?.pkl || "-"}
                          </td>
                          <td className="agent-view-user-table-data">
                            {val?.lorry || "-"}
                          </td>
                          <td className="agent-view-user-table-data">
                            {val?.agentName || "-"}
                          </td>
                          <td className="agent-view-user-table-data">
                            {val?.date || "-"}
                          </td>

                          {/* PKL REPORT Button */}
                          <td className="agent-view-user-table-data">
                            <div className="d-flex align-items-center justify-content-center gap-1">
                              <button
                                className="packinglist-view-btn"
                                onClick={() => {
                                  if (isEditable) {
                                    setDownloadPopUp(true);
                                    setPopUpData({
                                      ...popUpData,
                                      key: "pklreport",
                                      items: val,
                                    });
                                  }
                                }}
                                disabled={!isEditable}
                                style={{
                                  cursor: isEditable
                                    ? "pointer"
                                    : "not-allowed",
                                  opacity: isEditable ? 1 : 0.5,
                                }}
                                title={
                                  isEditable
                                    ? "Click to download PKL Report"
                                    : "PKL Report download disabled for this date"
                                }
                              >
                                PKL REPORT
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td className="py-2 data-entry-sub-title" colSpan="16">
                        No Records Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </>
          )}
        </div>
      </div>

      <PopUpModal isOpen={isPopupOpen} onClose={togglePopup}>
        <div className="img-block">
          <div style={{ width: "40%", height: "60%" }} className="mx-2 pt-2">
            <img src={logo} style={{ width: "100%", height: "100%" }} />
          </div>
        </div>
        <div className="d-flex flex-column align-items-center justify-content-center py-1">
          <h6 className="popup-content mb-3">
            Are you sure to delete the user detail?
          </h6>
          <div className="d-flex justify-content-center gap-5 mb-3">
            <button
              className="user-delete-button"
              onClick={() => {
                handleDelete();
                setPopupOpen(false);
              }}
            >
              OK
            </button>
            <button
              className="user-delete-button"
              onClick={() => {
                setPopupOpen(false);
              }}
            >
              NO
            </button>
          </div>
        </div>
      </PopUpModal>
      <PopUpModal isOpen={deletePopUp}>
        <div className="img-block">
          <div style={{ width: "40%", height: "60%" }} className="mx-2 pt-2">
            <img src={logo} style={{ width: "100%", height: "100%" }} />
          </div>
        </div>
        <div className="d-flex flex-column align-items-center justify-content-center py-1">
          <h6 className="popup-content mb-3">
            PackingList has been deleted successfully
          </h6>
          <button
            className="user-delete-button mb-3"
            onClick={() => {
              setDeletePopUp(false);
            }}
          >
            OK
          </button>
        </div>
      </PopUpModal>
      <PopUpModal isOpen={downloadPopUp}>
        <div className="img-block">
          <div style={{ width: "40%", height: "60%" }} className="mx-2 pt-2">
            <img src={logo} style={{ width: "100%", height: "100%" }} />
          </div>
        </div>
        <div className="py-4 d-flex justify-content-center align-items-center gap-2">
          {popUpData?.key === "pklreport" && (
            <>
              {Array.isArray(popUpData?.items?.newTeakRounds) &&
              popUpData?.items?.newTeakRounds?.length > 1 ? (
                <button
                  className="packinglist-download-button"
                  onClick={() => {
                    navigate("/pkldownload", { state: popUpData?.items });
                  }}
                >
                  Download Log
                </button>
              ) : Array.isArray(popUpData?.items?.newTeakSwan) &&
                popUpData?.items?.newTeakSwan?.length > 1 ? (
                <button
                  className="packinglist-download-button"
                  onClick={() => {
                    navigate("/swandownload", { state: popUpData?.items });
                  }}
                >
                  Download Sawn
                </button>
              ) : (
                <button className="packinglist-download-button" disabled>
                  No Reports Available
                </button>
              )}
            </>
          )}

          {popUpData?.key == "acreport" && (
            <>
              <button
                className="packinglist-download-button"
                // onClick={downloadAcReport}
                onClick={() => {
                  navigate("/acdownload", { state: popUpData?.items });
                }}
              >
                Download
              </button>
            </>
          )}
          {popUpData?.key === "mgirthpklreport" && (
            <>
              {Array.isArray(popUpData?.items?.newTeakRounds) &&
              popUpData?.items?.newTeakRounds?.length > 1 ? (
                <button
                  className="packinglist-download-button"
                  onClick={() => {
                    navigate("/mgirthDownload", { state: popUpData?.items });
                  }}
                >
                  Download M-Girth
                </button>
              ) : (
                <button className="packinglist-download-button" disabled>
                  No Reports Available
                </button>
              )}
            </>
          )}
          <button
            onClick={() => {
              setDownloadPopUp(false);
            }}
            className="packinglist-download-button"
          >
            Cancel
          </button>
          <button
            className="packinglist-download-button"
            onClick={() => {
              setDownloadPopUp(false);
              setSharePopUp(true);
            }}
          >
            Share
          </button>
        </div>
      </PopUpModal>
      <PopUpModal isOpen={sharePopUp} onClose={toggleShare}>
        <div className="img-block">
          <div style={{ width: "40%", height: "60%" }} className="mx-2 pt-2">
            <img src={logo} style={{ width: "100%", height: "100%" }} />
          </div>
        </div>
        <div className="d-flex justify-content-center align-items-center gap-4 pt-3 pb-4">
          <div
            style={{ width: "60px", height: "60px" }}
            onClick={handleWhatsAppClick}
          >
            <img
              src={Images?.whatsApp}
              style={{ width: "100%", height: "100%", cursor: "pointer" }}
            />
          </div>
          <div
            style={{ width: "60px", height: "60px" }}
            onClick={() => {
              setSharePopUp(false);
              setShareNotification(true);
            }}
          >
            <img
              src={Images?.sendIcon}
              style={{ width: "100%", height: "100%", cursor: "pointer" }}
            />
          </div>
          <div
            style={{ width: "60px", height: "60px" }}
            onClick={handleGmailClick}
          >
            <img
              src={Images?.gmail}
              style={{ width: "100%", height: "100%", cursor: "pointer" }}
            />
          </div>
        </div>
      </PopUpModal>
      <PopUpModal isOpen={shareNotification} onClose={toggleShareNotification}>
        <div className="img-block">
          <div style={{ width: "40%", height: "60%" }} className="mx-2 pt-2">
            <img src={logo} style={{ width: "100%", height: "100%" }} />
          </div>
        </div>
        <h6 className="view_customer_popup_heading my-3">Customer Details</h6>
        <div className="row my-2 mx-2">
          <div className="col-6">
            <label className="popup_customer_label">Customer ID</label>
          </div>
          <div className="col-6">
            <Controller
              control={control}
              name="customerID"
              render={({ field }) => (
                <input
                  className="add_customer_input_field"
                  {...field}
                  type="text"
                  placeholder="BTC0001"
                />
              )}
            />
          </div>
        </div>
        <div className="row my-2 mx-2">
          <div className="col-6">
            <label className="popup_customer_label">Customer Name</label>
          </div>
          <div className="col-6">
            <Controller
              control={control}
              name="customerName"
              render={({ field }) => (
                <input
                  className="add_customer_input_field"
                  {...field}
                  type="text"
                  placeholder="sabari"
                />
              )}
            />
          </div>
        </div>
        <div className="row my-2 mx-2">
          <div className="col-6">
            <label className="popup_customer_label">Mobile Number</label>
          </div>
          <div className="col-6">
            <Controller
              control={control}
              name="customerID"
              render={({ field }) => (
                <input
                  className="add_customer_input_field"
                  {...field}
                  type="text"
                  placeholder="BTC0001"
                />
              )}
            />
          </div>
        </div>
        <div className="row my-4 mx-2">
          <div className="col-12">
            <button className="view_customer_send_button">SEND TO</button>
          </div>
        </div>
      </PopUpModal>

      <PopUpModal
        isOpen={modifyPopup}
        onClose={() => {
          setModifyPopup(false);
        }}
      >
        <div className="img-block">
          <div style={{ width: "40%", height: "60%" }} className="mx-2 pt-2">
            <img src={logo} style={{ width: "100%", height: "100%" }} />
          </div>
        </div>
        <div className="d-flex flex-wrap justify-content-center gap-3 p-3">
          <div
            className="iframe_card"
            onClick={() =>
              navigate("/pkldownload", { state: popUpData?.items })
            }
            style={{ cursor: "pointer" }}
          >
            <iframe
              title="pkl-report.pdf"
              className="iframe-container"
              // src="/pkldownload"
            ></iframe>

            <span className="iframe_label">PKL Report.pdf</span>
          </div>

          <div className="iframe_card">
            <iframe title="AC report.pdf" className="iframe-container" />
            <span
              className="iframe_label"
              onClick={() =>
                navigate("/acdownload", { state: popUpData?.items })
              }
              style={{ cursor: "pointer" }}
            >
              AC Report.pdf
            </span>
          </div>
          <div
            className="iframe_card"
            onClick={() =>
              navigate("/mgirthDownload", { state: popUpData?.items })
            }
          >
            <iframe
              title="M-Girth PKL Report.pdf"
              className="iframe-container"
            />
            <span className="iframe_label">
              {popUpData?.items?.mtsNewValue ? (
                <> B-PKL Report.pdf</>
              ) : (
                <> M-Girth PKL Report.pdf</>
              )}
            </span>
          </div>
        </div>
        <div className="my-5 d-flex gap-2 justify-content-center">
          {/* <button className="packinglist-download-button">DOWNLOAD</button> */}
          <button
            className="packinglist-download-button"
            onClick={() => {
              setModifyPopup(false);
            }}
          >
            CANCEL
          </button>
          <button
            className="packinglist-download-button"
            onClick={() => {
              setModifyPopup(false);
            }}
          >
            SHARE
          </button>
        </div>
      </PopUpModal>
    </>
  );
}
